import { render, staticRenderFns } from "./PurPD.vue?vue&type=template&id=04a86e78"
import script from "./PurPD.vue?vue&type=script&lang=js"
export * from "./PurPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports